import * as Types from '../types';
import { Environment } from '../../../config';
import request from '../../../utils/request';
import { LanguagesEnum } from 'constants/languages';
import _, { StringNullableChain } from 'lodash';
import * as ParalistConstants from 'constants/paralist';

export type IParalistByGroupData = Array<{
  id: number;
  name: string;
}>;

interface IParalistByGroupOutput extends Types.ResponseOutput {
  data: IParalistByGroupData;
}
export const getParalistByGroupcode = async (
  groupcode: ParalistConstants.ParalistGroupCodes
): Promise<IParalistByGroupOutput> => {
  const { data }: any = await request(
    'get',
    `${Environment.API_BASE_URL}/api/paralist/getByGroupcode?groupcode=${groupcode}`
  );
  return data;
};
